<!--
  --
  -- エラーページ
  --
  -->
<template>
  <v-app>
    <v-main>
      <v-container fluid class="d-flex flex-column justify-center align-center h-full">
        <c-header
          :code="code"
          :caption="caption"
        />

        <c-details
          v-if="messages.length > 0"
          :messages="messages"
        />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import CHeader from './CHeader'
import CDetails from './CDetails'

export default {
  name: 'CError',
  components: {
    CHeader,
    CDetails
  },
  props: {
    /**
     * エラーコード
     */
    code: {
      type: [Number, String],
      required: true
    },

    /**
     * エラータイトル
     */
    caption: {
      type: String,
      required: true
    },

    /**
     * メッセージ
     */
    messages: {
      type: Array,
      default: () => []
    }
  }
}
</script>
